// extracted by mini-css-extract-plugin
export var icon = "_7t-1";
export var subtext = "_7t-0";